import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useGetSearchProductListQuery } from "../../../utils/api/product/product.api";
import { getImage } from "../../../utils/Utils";
import { getProductPriceLabels } from "../../../utils/productPricing";
import { AlertInfo } from "../../common/Alert";
import Empty from "../../../assets/images/appImages/category.png";
import { getVendeur } from "../../HomePage/HomePage";

function SearchForm() {
  const Vendeur = getVendeur();
  const [isDivVisible, setIsDivVisible] = useState(false);
  const { slug } = useParams<{ slug: string }>();
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    setQuery("");
    setDebouncedQuery("");
  }, [slug]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(query.trim());
    }, 300);
    return () => clearTimeout(timer);
  }, [query]);

  const searchTerm = debouncedQuery.length >= 3 ? debouncedQuery : "";
  const { data = { results: [] }, isFetching } = useGetSearchProductListQuery(
    {
      q: searchTerm,
      limit: 20,
    },
    { skip: !searchTerm }
  );

  const results = data?.results ?? [];

  const goToResults = () => {
    const term = query.trim();
    if (term.length < 3) return;
    navigate(`/recherche?q=${encodeURIComponent(term)}`);
    setIsDivVisible(false);
  };

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
    setIsDivVisible(true);
  };

  return (
    <div className="input-group-search relative-search-form">
      <div className="input-group-search-inner">
        <input
          type="text"
          className="form-control search-field"
          value={query}
          onChange={handleChangeSearch}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              goToResults();
            }
          }}
          onFocus={() => setIsDivVisible(true)}
          onBlur={() => setTimeout(() => setIsDivVisible(false), 300)}
          placeholder="Rechercher un produit"
          aria-label="Rechercher un produit"
        />
        <span
          className="search-icon-right"
          role="button"
          tabIndex={0}
          aria-label="Lancer la recherche"
          onMouseDown={(e) => e.preventDefault()}
          onClick={goToResults}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              goToResults();
            }
          }}
        >
          <i className="fa fa-search" />
        </span>
        {isDivVisible && query.trim().length >= 3 && (
          <div className="list-container">
            <ul className="search-result-container">
              {isFetching && (
                <li className="search-result-item">
                  <AlertInfo message="Recherche en cours..." />
                </li>
              )}
              {!isFetching &&
                results.map((item: any) => (
                  <li className="search-result-item" key={item?.id}>
                    <Link
                      to={`/produit/${item?.slug}`}
                      state={item}
                      className="no-link"
                    >
                      <div className="row align-items-center">
                        <div className="col-sm-3 m-b-20 m-r-9">
                          <img
                            loading="lazy"
                            className="img-thumbs-commande-item"
                            src={getImage(
                              item?.type == "taille_unique"
                                ? item?.images?.[0]?.image
                                : item?.variations?.[0]?.images?.[0]?.image ||
                                  Empty
                            )}
                            alt={item?.nom}
                            style={{
                              width: "75px",
                              height: "75px",
                            }}
                          />
                        </div>
                        <div className="pl-lg-0 col-sm-8 m-b-20">
                          <p className="name-prduct-search fs-15">{item?.nom}</p>
                          <div className="content-price-product-solde justify-content-start align-items-baseline">
                            {!!item?.id && (
                              <p className="price-solde-product-item mb-0">
                                {
                                  getProductPriceLabels(
                                    item,
                                    Vendeur?.devise
                                  ).display
                                }
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              {!isFetching && results.length === 0 && (
                <li className="search-result-item">
                  <AlertInfo message="Aucun résultat trouvé!" />
                </li>
              )}
              {!isFetching && results.length > 0 && (
                <li className="search-result-item">
                  <button
                    type="button"
                    className="btn btn-link w-100 text-center"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={goToResults}
                  >
                    Voir tous les résultats
                  </button>
                </li>
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchForm;
